import { patchForeColorPlugin } from './textcolor';

patchForeColorPlugin();
